<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <draggable v-model="columnData">
                <div v-for="item in columnData" :key="item.ColumnCode">
                    <div class="set-item">
                        <el-checkbox :disabled="isCantSet" :checked="item.IsSearch" v-model="item.IsSearch" border class="item-canset"></el-checkbox>
                        <el-tag class="item-cname2" effect="plain">
                            {{ item.Separator }}
                        </el-tag>
                    </div>
                </div>
            </draggable>
            <div v-if="separatorObj.IsSeparator" class="item-sep">
                <el-checkbox disabled :checked="separatorObj.IsSearch" border class="item-canset"></el-checkbox>
                <el-input placeholder="请输入分隔符" v-model="separatorObj.Separator">
                    <template slot="prepend">分隔符</template>
                </el-input>
            </div>
            <i v-if="separatorObj.IsSeparator" class="el-icon-info sep-info"
                >当前分割符为“{{ separatorObj.Separator == ' ' ? separatorObj.Separator + '(空格)' : separatorObj.Separator }}”</i
            >
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
            <el-button class="search-btn" type="warning" @click="restoreDefault">恢复默认</el-button>
            <el-button class="search-btn" @click="closeDialog(false)">取消</el-button>
            <el-button class="search-btn btn-primary" @click="submit">保存设置</el-button>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    name: '',
    components: {
        draggable
    },
    data() {
        return {
            columnData: [],
            loading: false,
            separatorObj: {},
            isCantSet: false
        };
    },
    created() {
        // 阻止火狐的默认拖拽事件
        document.body.ondrop = event => {
            event.preventDefault();
            event.stopPropagation();
        };
    },
    mounted() {
        this.getSysConfig().then(() => {
            this.getSetsData();
        });
    },
    methods: {
        getSysConfig() {
            return new Promise(resolve => {
                this.$util.getSysConfig('lhcxwgzssyq').then(data => {
                    if (data) {
                        this.isCantSet = data.Result;
                    }
                    resolve();
                });
            });
        },
        getSetsData() {
            this.loading = true;
            this.$util.getJointSearchSetsData(false).then(data => {
                let separatorIdx = data.findIndex(f => f.IsSeparator);
                // 判断是否有分隔符
                if (separatorIdx > -1) {
                    let sArr = data.splice(separatorIdx, 1);
                    this.separatorObj = sArr[0];
                }
                this.columnData = data;
                this.loading = false;
            });
        },
        submit() {
            let canSunbmit = false;
            this.columnData.forEach(item => {
                if (item.IsSearch) {
                    canSunbmit = true;
                    return;
                }
            });

            if (!canSunbmit) {
                this.$util.warningMsg('联合搜索必须有一项或多项进行搜索');
                return;
            }

            // 重新排序
            let dataSort = this.columnData.map((m, i) => {
                return Object.assign(m, { SortNum: i + 1 });
            });
            if (this.separatorObj.IsSeparator) {
                if (!this.separatorObj.Separator) {
                    this.$util.warningMsg('请输入分隔符');
                    return;
                }
                dataSort.push(this.separatorObj);
            }
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/SubmitStaffJointSearchSets',
                    data: { JointSetsData: dataSort },
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$util.clearLocalStorage('js_goods');
                    this.closeDialog(true);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        restoreDefault() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: `/api/EntpInfoManagement/RestoreDefaultJointSearchSets`,
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$util.clearLocalStorage('js_goods');
                    this.closeDialog(true);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scope>
.set-content {
    display: flex;
    flex-direction: column;

    .set-item {
        display: flex;
        flex-direction: row;
        height: 40px;

        .item-canset {
            width: 7%;
            border-radius: 5px 0 0 5px;
        }

        .item-cname2 {
            width: 93% !important;
        }
    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-input__inner {
        border-radius: 0;
    }
    .el-button {
        border-radius: 0;
    }
    .el-tag {
        height: 100%;
        width: 100%;
        border-radius: 0 5px 5px 0;
        font-size: 14px;
        line-height: 35px;
    }
    .item-sep {
        display: flex;
        flex-direction: row;
        height: 40px;
        margin-top: 30px;

        .item-canset {
            width: 7%;
            border-radius: 5px 0 0 5px;
        }

        .el-input__inner {
            border-radius: 0 5px 5px 0;
        }
    }
    .sep-info {
        margin-top: 10px;
        color: rgb(155, 153, 153);
    }
}
</style>
